module.exports = __webpack_public_path__ + "img/06.c99258a6.png";